const headers = () => {
    return { headers: { "x-access-token": localStorage.getItem("access-token") } };
}

export default headers;